import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiLogOut, FiTrash2, FiChevronUp, FiChevronDown } from "react-icons/fi";
import {
  FaMoneyBillWave,
  FaPiggyBank,
  FaChartLine,
  FaUsers,
  FaCalendarDay,
  FaCalendarAlt,
  FaWallet,
  FaCoins,
  FaChartBar,
} from "react-icons/fa";
import logo from "../assets/images/logo_2.png";
import { Link, useNavigate } from "react-router-dom";

export default function Dashboard() {
  // ===== i18n (labels only; nav stays English) =====
  const [lang, setLang] = useState("en"); // 'en' | 'ja' | 'fa' | 'zh'
  const [dir, setDir] = useState("ltr");  // 'ltr' | 'rtl'

  const normalizeLang = (raw) => {
    const s = String(raw || "").trim().toLowerCase();
    if (s === "jp" || s === "ja") return "ja";
    if (s === "ir" || s === "fa") return "fa";
    if (s === "cn" || s === "zh") return "zh";
    return "en";
  };

  const DICT = {
    en: {
      TradingAccounts: "Trading Accounts",
      SearchPH: "Search by name or account #...",
      "TOTAL PROFIT": "TOTAL PROFIT",
      "TOTAL DEPOSIT": "TOTAL DEPOSIT",
      "TOTAL EQUITY": "TOTAL EQUITY",
      "ACTIVE ACCOUNTS": "ACTIVE ACCOUNTS",
      "REAL WITHDRAWAL": "REAL WITHDRAWAL",
      "INTERNAL TRANSFERS": "INTERNAL TRANSFERS",
      "INTERNAL TRANSFERS EXCLUDED": "Internal transfers excluded",
      "NET PROFIT RATE": "純利益率",
      "TODAY'S PROFIT": "TODAY'S PROFIT",
      "LAST WEEK PROFIT": "LAST WEEK PROFIT",
      "TOTAL FLOATING PROFIT": "TOTAL FLOATING PROFIT",
      "CURRENT FLOATING DRAWDOWN": "CURRENT FLOATING DRAWDOWN",
      "CURRENT FLOATING PROFIT": "CURRENT FLOATING PROFIT",
      "LAST WEEK'S TOTAL FLOATING PROFIT": "LAST WEEK'S TOTAL FLOATING PROFIT",
      // Mobile KPI short labels
      PROFIT: "PROFIT",
      DEPOSIT: "DEPOSIT",
      EQUITY: "EQUITY",
      ACCOUNTS: "ACCOUNTS",
      TODAY: "TODAY",
      WEEK: "WEEK",
      "FLOAT PROFIT": "FLOAT PROFIT",
      // Table headers:
      "No.": "No.",
      "Name": "Name",
      "Acc #": "Acc #",
      "StartDate": "StartDate",
      "Bal": "Bal",
      "Eq": "Eq",
      "Dep": "Dep",
      "W/d": "Real W/d",
      "Float PnL": "Float PnL",
      "Mrgn%": "Mrgn%",
      "Today PnL": "Today PnL",
      "Wk PnL": "Wk PnL",
      "Tot PnL": "Tot PnL",
      "Open": "Open",
      "Sym": "Sym",
      "Lot": "Lot",
      "Sig": "Sig",
      "Pend": "Pend",
      "Act": "Act",
      ConfirmDelete: "Are you sure you want to delete this account?",
    },
    ja: {
      TradingAccounts: "取引アカウント",
      SearchPH: "名前または口座番号で検索...",
      "TOTAL PROFIT": "総利益",
      "TOTAL DEPOSIT": "総入金",
      "TOTAL EQUITY": "総有効証拠金",
      "ACTIVE ACCOUNTS": "稼働口座数",
      "REAL WITHDRAWAL": "実出金",
      "INTERNAL TRANSFERS": "内部振替",
      "INTERNAL TRANSFERS EXCLUDED": "内部振替を除外",
      "NET PROFIT RATE": "純利益率",
      "TODAY'S PROFIT": "本日の損益",
      "LAST WEEK PROFIT": "先週の損益",
      "TOTAL FLOATING PROFIT": "評価損益合計",
      "CURRENT FLOATING DRAWDOWN": "現在の含み損ドローダウン",
      "CURRENT FLOATING PROFIT": "現在の含み益",
      "LAST WEEK'S TOTAL FLOATING PROFIT": "先週の評価損益合計",
      PROFIT: "利益",
      DEPOSIT: "入金",
      EQUITY: "有効証拠金",
      ACCOUNTS: "口座数",
      TODAY: "本日",
      WEEK: "週間",
      "FLOAT PROFIT": "評価損益",
      "No.": "No.",
      "Name": "名前",
      "Acc #": "口座番号",
      "StartDate": "開始日",
      "Bal": "残高",
      "Eq": "有効証拠金",
      "Dep": "入金",
      "W/d": "実出金",
      "Float PnL": "評価損益",
      "Mrgn%": "証拠金率",
      "Today PnL": "本日の損益",
      "Wk PnL": "週損益",
      "Tot PnL": "累計損益",
      "Open": "保有",
      "Sym": "銘柄",
      "Lot": "ロット",
      "Sig": "シグナル",
      "Pend": "指値",
      "Act": "操作",
      ConfirmDelete: "この口座を削除しますか？",
    },
    fa: {
      TradingAccounts: "حساب‌های معاملاتی",
      SearchPH: "جستجو با نام یا شماره حساب...",
      "TOTAL PROFIT": "سود کل",
      "TOTAL DEPOSIT": "واریزی کل",
      "TOTAL EQUITY": "اکوئیتی کل",
      "ACTIVE ACCOUNTS": "تعداد حساب‌های فعال",
      "REAL WITHDRAWAL": "برداشت واقعی",
      "INTERNAL TRANSFERS": "انتقال‌های داخلی",
      "INTERNAL TRANSFERS EXCLUDED": "انتقال‌های داخلی محاسبه نشده‌اند",
      "NET PROFIT RATE": "نرخ سود خالص",
      "TODAY'S PROFIT": "سود امروز",
      "LAST WEEK PROFIT": "سود هفته گذشته",
      "TOTAL FLOATING PROFIT": "سود/زیان شناور کل",
      "CURRENT FLOATING DRAWDOWN": "افت شناور فعلی",
      "CURRENT FLOATING PROFIT": "سود شناور فعلی",
      "LAST WEEK'S TOTAL FLOATING PROFIT": "شناور هفته گذشته",
      PROFIT: "سود",
      DEPOSIT: "واریز",
      EQUITY: "اکوئیتی",
      ACCOUNTS: "حساب‌ها",
      TODAY: "امروز",
      WEEK: "هفته",
      "FLOAT PROFIT": "شناور",
      "No.": "ردیف",
      "Name": "نام",
      "Acc #": "شماره حساب",
      "StartDate": "تاریخ شروع",
      "Bal": "بالانس",
      "Eq": "اکوئیتی",
      "Dep": "واریز",
      "W/d": "برداشت واقعی",
      "Float PnL": "شناور",
      "Mrgn%": "درصد مارجین",
      "Today PnL": "سود امروز",
      "Wk PnL": "سود هفته",
      "Tot PnL": "سود کل",
      "Open": "باز",
      "Sym": "سیمبل",
      "Lot": "لات",
      "Sig": "سیگنال",
      "Pend": "در انتظار",
      "Act": "عملیات",
      ConfirmDelete: "آیا از حذف این حساب مطمئن هستید؟",
    },
    zh: {
      TradingAccounts: "交易账户",
      SearchPH: "按名称或账号搜索…",
      "TOTAL PROFIT": "总利润",
      "TOTAL DEPOSIT": "总入金",
      "TOTAL EQUITY": "总净值",
      "ACTIVE ACCOUNTS": "活跃账户",
      "REAL WITHDRAWAL": "实际出金",
      "INTERNAL TRANSFERS": "内部转账",
      "INTERNAL TRANSFERS EXCLUDED": "不含内部转账",
      "NET PROFIT RATE": "净利润率",
      "TODAY'S PROFIT": "今日盈亏",
      "LAST WEEK PROFIT": "上周盈亏",
      "TOTAL FLOATING PROFIT": "总浮动盈亏",
      "CURRENT FLOATING DRAWDOWN": "当前浮动回撤",
      "CURRENT FLOATING PROFIT": "当前浮动盈利",
      "LAST WEEK'S TOTAL FLOATING PROFIT": "上周浮动盈亏",
      PROFIT: "利润",
      DEPOSIT: "入金",
      EQUITY: "净值",
      ACCOUNTS: "账户数",
      TODAY: "今日",
      WEEK: "本周",
      "FLOAT PROFIT": "浮动盈亏",
      "No.": "序号",
      "Name": "名称",
      "Acc #": "账号",
      "StartDate": "开始日期",
      "Bal": "余额",
      "Eq": "净值",
      "Dep": "入金",
      "W/d": "实际出金",
      "Float PnL": "浮动盈亏",
      "Mrgn%": "保证金比率",
      "Today PnL": "今日盈亏",
      "Wk PnL": "周盈亏",
      "Tot PnL": "总盈亏",
      "Open": "持仓",
      "Sym": "品种",
      "Lot": "手数",
      "Sig": "信号",
      "Pend": "挂单",
      "Act": "操作",
      ConfirmDelete: "确定删除该账户吗？",
    },
  };

  const t = (key) => DICT[lang]?.[key] ?? key;
  // ===== /i18n =====

  const [accounts, setAccounts] = useState([]);
  const [search, setSearch] = useState("");
  const [darkMode, setDarkMode] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [maxTotalDrawdown, setMaxTotalDrawdown] = useState({ amount: 0, percent: 0, recordedAt: "" });
    const [currentUsername, setCurrentUsername] = useState("");

  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const user = (() => {
      try { return JSON.parse(localStorage.getItem("user")); } catch { return null; }
    })();

    if (!user?.Username) {
      navigate("/login");
      return;
    }

    setCurrentUsername(user.Username);

    // Load language from backend (no logic change)
    const loadLang = async () => {
      try {
        const r = await axios.get(`${BASE_URL}/api/login/language/${encodeURIComponent(user.Username)}`);
        const raw = r.data?.Language || "EN";
        const L = normalizeLang(raw);
        setLang(L);
        const d = (L === "fa") ? "rtl" : "ltr";
        setDir(d);
        document.documentElement.dir = d;
      } catch {
        setLang("en"); setDir("ltr"); document.documentElement.dir = "ltr";
      }
    };
    loadLang();

    // Data polling (unchanged)
    const fetchData = async () => {
      try {
        const url =
          user.Username.toLowerCase() === "admin"
            ? `${BASE_URL}/api/live-data/all`
            : `${BASE_URL}/api/live-data/for-user/${encodeURIComponent(user.Username)}`;

        const res = await axios.get(url);
        if (res.data?.success) setAccounts(res.data.data || []);
      } catch (err) {
        console.error("Fetch failed:", err);
      }
    };

    fetchData();
    const id = setInterval(fetchData, 3000);
    return () => clearInterval(id);
    // eslint-disable-next-line
  }, []);

    // Admin sees every live account together. Customer logins remain restricted
  // by the backend to only the MT4/MT5 accounts assigned to that customer.
  const visibleAccounts = accounts;
useEffect(() => {
  if (!visibleAccounts.length || !currentUsername) return;

  const currentLoss = Math.abs(
    visibleAccounts.reduce(
      (sum, acc) => sum + Math.min(Number(acc.Floating_Profits || 0), 0),
      0
    )
  );

  const currentBalance = visibleAccounts.reduce(
    (sum, acc) => sum + Number(acc.Account_Balance || 0),
    0
  );

  const currentPercent =
    currentBalance > 0 ? (currentLoss / currentBalance) * 100 : 0;

  setMaxTotalDrawdown((previous) => {
    if (currentPercent <= Number(previous.percent || 0)) return previous;

    return {
      amount: currentLoss,
      percent: currentPercent,
      recordedAt: new Date().toISOString(),
    };
  });
}, [visibleAccounts, currentUsername]);
  const handleDelete = async (accountNumber) => {
    if (window.confirm(t("ConfirmDelete"))) {
      try {
        const res = await axios.delete(`${BASE_URL}/api/live-data/${accountNumber}`);
        if (res.data.success) {
          setAccounts((prev) => prev.filter((acc) => acc.Account_Number !== accountNumber));
        } else {
          alert(res.data.message || "Account not found on server.");
        }
      } catch (err) {
        console.error("Delete failed", err);
        alert("Failed to delete account.");
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") direction = "desc";
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return null;
    return sortConfig.direction === "asc" ? <FiChevronUp className="inline" /> : <FiChevronDown className="inline" />;
  };

  const sortedAccounts = [...visibleAccounts].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const aValue = a[sortConfig.key] || "";
    const bValue = b[sortConfig.key] || "";
    const isNumeric = !isNaN(aValue) && !isNaN(bValue);
    if (isNumeric) {
      const numA = parseFloat(aValue);
      const numB = parseFloat(bValue);
      return sortConfig.direction === "asc" ? numA - numB : numB - numA;
    } else {
      const aa = (aValue ?? "").toString().toLowerCase();
      const bb = (bValue ?? "").toString().toLowerCase();
      if (aa < bb) return sortConfig.direction === "asc" ? -1 : 1;
      if (aa > bb) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
  });

  const filtered = sortedAccounts.filter((acc) => {
    const searchTerm = search.toLowerCase();
    return (
      acc.Account_Name?.toLowerCase().includes(searchTerm) ||
      acc.Account_Number?.toString().includes(searchTerm)
    );
  });

  const formatCurrency = (val) => {
    const n = Number(val);
    return isNaN(n) ? "$0.00" : `$${n.toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
  };
  const formatNZD = (val) => {
    const n = Number(val);
    return `${Number.isFinite(n) ? n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"} NZD`;
  };
  const formatMarginLevel = (val) => {
    const n = Number(val);
    return isNaN(n) ? "0.00%" : `${n.toFixed(2)}%`;
  };
  const getMarginLevelColor = (val) => {
    const n = Number(val);
    if (isNaN(n)) return "";
    return n >= 500 ? "text-green-500" : "text-red-500";
  };
  const getPnLColor = (val) => {
    const n = Number(val);
    if (isNaN(n)) return "";
    return n >= 0 ? "text-green-400" : "text-red-400";
  };

  const formatDate = (v) => {
    if (!v) return "-";
    const d = new Date(v);
    return isNaN(d.getTime()) ? "-" : d.toLocaleDateString();
  };

  const totalProfit = visibleAccounts.reduce((sum, acc) => sum + Number(acc.Profit_Amt || 0), 0);
  const totalDeposit = visibleAccounts.reduce((sum, acc) => sum + Number(acc.Deposit || 0), 0);
  const totalEquity = visibleAccounts.reduce((sum, acc) => sum + Number(acc.Account_Equity || 0), 0);
  const totalRealWithdrawal = visibleAccounts.reduce(
    (sum, acc) => sum + Number(acc.Real_Withdrawal ?? acc.Withdraw ?? 0),
    0
  );
  // Count the outgoing side only so the same internal transfer is not doubled
  // when both source and destination accounts are visible.
  const totalInternalTransfers = visibleAccounts.reduce(
    (sum, acc) => sum + Number(acc.Internal_Transfer_Out || 0),
    0
  );
  const totalTodayProfit = visibleAccounts.reduce((sum, acc) => sum + Number(acc.Profit_Per || 0), 0);
  const totalWeekProfit = visibleAccounts.reduce((sum, acc) => sum + Number(acc.Last_Week_Profit || 0), 0);
  const totalFloatingProfit = visibleAccounts.reduce((sum, acc) => sum + Number(acc.Floating_Profits || 0), 0);
  const totalBalance = visibleAccounts.reduce((sum, acc) => sum + Number(acc.Account_Balance || 0), 0);
  const floatingDrawdownPercent = totalBalance > 0 ? (totalFloatingProfit / totalBalance) * 100 : 0;
  const isFloatingDrawdown = totalFloatingProfit < 0;
  const floatingKpiLabel = isFloatingDrawdown
    ? t("CURRENT FLOATING DRAWDOWN")
    : t("CURRENT FLOATING PROFIT");
  const floatingKpiColor = isFloatingDrawdown ? "bg-red-600" : "bg-green-600";
  const floatingKpiTextColor = isFloatingDrawdown ? "text-red-400" : "text-green-400";
  const floatingKpiPercentText = `${floatingDrawdownPercent >= 0 ? "+" : ""}${floatingDrawdownPercent.toFixed(2)}%`;
  const activeAccountsForEquityGain = visibleAccounts.filter((acc) => Number(acc.Account_Equity || 0) > 0);

const totalStartCapital = activeAccountsForEquityGain.reduce(
  (sum, acc) => sum + Number(acc.Initial_Real_Capital || 0),
  0
);

const hasMissingStartCapital = activeAccountsForEquityGain.some(
  (acc) => Number(acc.Initial_Real_Capital || 0) <= 0
);

const equityGainPercent =
  activeAccountsForEquityGain.length > 0 &&
  totalStartCapital > 0 &&
  !hasMissingStartCapital
    ? ((totalProfit + totalFloatingProfit) / totalStartCapital) * 100
    : null;
const equityGainText =
  equityGainPercent === null
    ? t("NET PROFIT RATE") === "純利益率" ? "準備中" : "—"
    : `${equityGainPercent >= 0 ? "+" : ""}${equityGainPercent.toFixed(2)}%`;

const equityGainColor =
  equityGainPercent === null
    ? "text-purple-300"
    : equityGainPercent >= 0
      ? "text-yellow-400"
      : "text-red-400";

  // Define table columns with their corresponding data keys
  const tableColumns = [
    { header: "No.", key: null },
    { header: "Name", key: "Account_Name" },
    { header: "Acc #", key: "Account_Number" },
    { header: "StartDate", key: "Account_Created_At" },
    { header: "Bal", key: "Account_Balance" },
    { header: "Eq", key: "Account_Equity" },
    { header: "Dep", key: "Deposit" },
    { header: "W/d", key: "Real_Withdrawal" },
    { header: "Float PnL", key: "Floating_Profits" },
    { header: "Mrgn%", key: "Margin_Level" },
    { header: "Today PnL", key: "Profit_Per" },
    { header: "Wk PnL", key: "Last_Week_Profit" },
    { header: "Tot PnL", key: "Profit_Amt" },
    { header: "Open", key: "Open_Positions" },
    { header: "Sym", key: "Highest_Position_Symbol" },
    { header: "Lot", key: "Highest_Position_Lot_Size" },
    { header: "Sig", key: "Highest_Position_Signal" },
    { header: "Pend", key: "Pending_Orders" },
    { header: "Act", key: null },
  ];

  return (
    <div dir={dir} className={`min-h-screen font-sans ${darkMode ? "bg-black text-white" : "bg-white text-black"}`}>
      {/* Mobile Header (nav stays English) */}
      {isMobile && (
        <div className={`w-full px-4 py-3 flex justify-between items-center ${darkMode ? "bg-[#13162C]" : "bg-gray-100"} sticky top-0 z-50`}>
          <div className="flex items-center gap-2">
            <img src={logo} className="h-8" alt="Logo" />
            <h1 className="text-lg font-bold text-white">Dashboard</h1>
          </div>
          <div className="flex items-center gap-2">
            <label className="inline-flex relative items-center cursor-pointer">
              <input type="checkbox" checked={darkMode} onChange={() => setDarkMode(!darkMode)} className="sr-only peer" />
              <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
            <button onClick={handleLogout} className="bg-red-600 p-2 rounded text-sm">
              <FiLogOut className="text-white" />
            </button>
          </div>
        </div>
      )}

      {/* Desktop Header (nav stays English) */}
      {!isMobile && (
        <nav className={darkMode ? "w-full px-6 py-4 flex justify-between items-center bg-[#13162C] shadow-md sticky top-0 z-50" : "w-full px-6 py-4 flex justify-between items-center bg-gray-100 shadow-md sticky top-0 z-50"}>
          <div className="flex items-center gap-3 shrink-0">
            <img src={logo} className="h-10" alt="Logo" />
            <h1 className="text-2xl font-bold text-white whitespace-nowrap">Account Dashboard</h1>
          </div>
          <div className="flex items-center gap-4 flex-wrap justify-center w-full max-w-[700px]">
            <Link to="/dashboard">
              <button className="bg-[#1FB0FF] px-3 py-1 rounded text-sm hover:bg-[#1597d6] transition">Dashboard</button>
            </Link>
            <Link to="/AddClient">
              <button className="text-sm px-3 py-1 rounded hover:bg-gray-700 transition">Add Client</button>
            </Link>
            <Link to="/Viewclients">
              <button className="text-sm px-3 py-1 rounded hover:bg-gray-700 transition">View/Edit Clients</button>
            </Link>
            <Link to="/AlertsSettings">
              <button className={`text-sm px-3 py-1 rounded transition ${darkMode ? "hover:bg-gray-700" : "hover:bg-gray-300"}`}>Alerts Settings</button>
            </Link>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm">{darkMode ? "🌙" : "☀️"}</span>
            <label className="inline-flex relative items-center cursor-pointer">
              <input type="checkbox" checked={darkMode} onChange={() => setDarkMode(!darkMode)} className="sr-only peer" />
              <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
            <button onClick={handleLogout} className="bg-red-600 px-4 py-2 rounded text-sm flex items-center gap-1">
              <FiLogOut /> Logout
            </button>
          </div>
        </nav>
      )}

      {/* Mobile Menu (nav stays English) */}
      {isMobile && (
        <div className={`w-full px-4 py-2 flex justify-between items-center ${darkMode ? "bg-gray-900" : "bg-gray-200"} shadow-sm`}>
          <Link to="/dashboard" className="text-center px-2 py-1 text-sm">Dashboard</Link>
          <Link to="/AddClient" className="text-center px-2 py-1 text-sm">Add Client</Link>
          <Link to="/Viewclients" className="text-center px-2 py-1 text-sm">View Clients</Link>
          <Link to="/AlertsSettings" className="text-center px-2 py-1 text-sm">Alerts</Link>
        </div>
      )}

      <div className="px-4 md:px-6 py-4 md:py-6 space-y-4 max-w-[100%] mx-auto">
        {/* KPIs - Mobile Layout */}
        {isMobile ? (
          <div className="grid grid-cols-2 gap-3">
            <MobileKPI icon={<FaWallet />} label={t("PROFIT")} value={formatCurrency(totalProfit)} color="bg-green-600" darkMode={darkMode} />
            <MobileKPI icon={<FaCoins />} label={t("DEPOSIT")} value={formatCurrency(totalDeposit)} color="bg-orange-600" darkMode={darkMode} />
            <EquityKPI icon={<FaChartLine />} label={t("EQUITY")} value={formatCurrency(totalEquity)} netLabel={t("NET PROFIT RATE")} netValue={equityGainText} netValueColor={equityGainColor} color="bg-blue-500" darkMode={darkMode} mobile />
            <MobileKPI icon={<FaUsers />} label={t("ACCOUNTS")} value={visibleAccounts.length} color="bg-blue-600" darkMode={darkMode} />
            <MobileKPI icon={<FaMoneyBillWave />} label={t("REAL WITHDRAWAL")} value={formatCurrency(totalRealWithdrawal)} subtitle={t("INTERNAL TRANSFERS EXCLUDED")} color="bg-purple-600" darkMode={darkMode} />
            <MobileKPI icon={<FaMoneyBillWave />} label={t("INTERNAL TRANSFERS")} value={formatCurrency(totalInternalTransfers)} color="bg-violet-600" darkMode={darkMode} />
            <MobileKPI icon={<FaCalendarDay />} label={t("TODAY")} value={formatCurrency(totalTodayProfit)} color="bg-red-600" darkMode={darkMode} />
            <MobileKPI icon={<FaCalendarAlt />} label={t("WEEK")} value={formatCurrency(totalWeekProfit)} color="bg-emerald-600" darkMode={darkMode} />
            <MobileKPI icon={<FaPiggyBank />} label={floatingKpiLabel} value={formatNZD(totalFloatingProfit)} valueColor={floatingKpiTextColor} subValue={floatingKpiPercentText} subValueColor={floatingKpiTextColor} color={floatingKpiColor} darkMode={darkMode} />
          </div>
        ) : (
          <>
            {/* Desktop KPI Layout */}
            <div className="w-full overflow-x-auto">
              <div className="grid grid-cols-4 gap-4 min-w-[920px]">
                <KPI icon={<FaWallet />} label={t("TOTAL PROFIT")} value={formatCurrency(totalProfit)} color="bg-green-600" darkMode={darkMode} />
                <KPI icon={<FaCoins />} label={t("TOTAL DEPOSIT")} value={formatCurrency(totalDeposit)} color="bg-orange-600" darkMode={darkMode} />
                <EquityKPI icon={<FaChartLine />} label={t("TOTAL EQUITY")} value={formatCurrency(totalEquity)} netLabel={t("NET PROFIT RATE")} netValue={equityGainText} netValueColor={equityGainColor} color="bg-blue-500" darkMode={darkMode} />
                <KPI icon={<FaUsers />} label={t("ACTIVE ACCOUNTS")} value={visibleAccounts.length} color="bg-blue-600" darkMode={darkMode} />
              </div>
            </div>

            <div className="w-full overflow-x-auto">
              <div className="grid grid-cols-4 gap-4 min-w-[920px]">
                <KPI icon={<FaMoneyBillWave />} label={t("REAL WITHDRAWAL")} value={formatCurrency(totalRealWithdrawal)} subtitle={t("INTERNAL TRANSFERS EXCLUDED")} color="bg-purple-600" darkMode={darkMode} />
                <KPI icon={<FaMoneyBillWave />} label={t("INTERNAL TRANSFERS")} value={formatCurrency(totalInternalTransfers)} color="bg-violet-600" darkMode={darkMode} />
                <KPI icon={<FaCalendarDay />} label={t("TODAY'S PROFIT")} value={formatCurrency(totalTodayProfit)} color="bg-red-600" darkMode={darkMode} />
                <KPI icon={<FaCalendarAlt />} label={t("LAST WEEK PROFIT")} value={formatCurrency(totalWeekProfit)} color="bg-emerald-600" darkMode={darkMode} />
              </div>
            </div>

            <div className="w-full overflow-x-auto">
              <div className="grid grid-cols-3 gap-4 min-w-[690px]">
                <KPI icon={<FaPiggyBank />} label={floatingKpiLabel} value={formatNZD(totalFloatingProfit)} valueColor={floatingKpiTextColor} subValue={floatingKpiPercentText} subValueColor={floatingKpiTextColor} color={floatingKpiColor} darkMode={darkMode} />
               <KPI icon={<FaChartBar />} label="MAXIMUM TOTAL DRAWDOWN / 過去最大トータルドローダウン" value={formatNZD(-maxTotalDrawdown.amount)} subValue={`-${Number(maxTotalDrawdown.percent || 0).toFixed(2)}%`} valueColor="text-red-400" subValueColor="text-red-400" color="bg-indigo-600" darkMode={darkMode} />
                <div></div>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="px-4 md:px-6 pb-6 md:pb-10 max-w-[100%] mx-auto">
        <div className={`flex ${isMobile ? "flex-col" : "justify-between items-center"} mb-2 gap-2`}>
          <h2 className="text-lg font-semibold whitespace-nowrap">{t("TradingAccounts")}</h2>
          <input
            type="text"
            placeholder={t("SearchPH")}
            className={`px-3 py-1 text-sm rounded ${darkMode ? "bg-gray-800 text-white border border-gray-600" : "bg-gray-100 text-black border border-gray-400"} ${isMobile ? "w-full mt-2" : ""}`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="w-full overflow-x-auto">
          <table className={`w-full ${isMobile ? "min-w-[900px]" : "min-w-[1080px]"} text-sm ${darkMode ? "bg-black text-white" : "bg-white text-black"}`}>
            <thead className={`${darkMode ? "bg-gray-800" : "bg-gray-200"}`}>
              <tr>
                {tableColumns.map((column, i) => (
                  <th
                    key={i}
                    className={`px-2 py-1 whitespace-nowrap text-xs cursor-pointer hover:bg-gray-700 ${column.key === "Account_Name" ? "text-left" : "text-center"}`}
                    onClick={() => column.key && requestSort(column.key)}
                  >
                    {t(column.header)}
                    {column.key && getSortIcon(column.key)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((acc, idx) => (
                <tr key={acc.Account_Number} className={idx % 2 === 0 ? (darkMode ? "bg-gray-900" : "bg-gray-100") : ""}>
                  <td className="whitespace-nowrap text-center">{idx + 1}</td>
                  <td className="whitespace-nowrap text-left">{acc.Account_Name}</td>
                  <td className="whitespace-nowrap text-center">{acc.Account_Number}</td>

                  <td className="whitespace-nowrap text-center">{formatDate(acc.StartTime)}</td>
                  <td className="whitespace-nowrap text-center">{formatCurrency(acc.Account_Balance)}</td>
                  <td className="whitespace-nowrap text-center">{formatCurrency(acc.Account_Equity)}</td>
                  <td className="whitespace-nowrap text-center">{formatCurrency(Number(acc.Deposit))}</td>
                  <td className="whitespace-nowrap text-center">{formatCurrency(Number(acc.Real_Withdrawal ?? acc.Withdraw ?? 0))}</td>
                  <td className={`whitespace-nowrap text-center ${acc.Floating_Profits >= 0 ? "text-green-400" : "text-red-400"}`}>{formatCurrency(acc.Floating_Profits)}</td>
                  <td className={`whitespace-nowrap text-center ${getMarginLevelColor(acc.Margin_Level)}`}>{formatMarginLevel(acc.Margin_Level)}</td>
                  <td className={`whitespace-nowrap text-center ${acc.Profit_Per >= 0 ? "text-green-400" : "text-red-400"}`}>{formatCurrency(acc.Profit_Per)}</td>
                  <td className={`whitespace-nowrap text-center ${getPnLColor(acc.Last_Week_Profit)}`}>{formatCurrency(Number(acc.Last_Week_Profit))}</td>
                  <td className={`whitespace-nowrap text-center ${getPnLColor(acc.Profit_Amt)}`}>{formatCurrency(acc.Profit_Amt)}</td>
                  <td className="whitespace-nowrap text-center">{acc.Open_Positions}</td>
                  <td className="whitespace-nowrap text-center">{acc.Highest_Position_Symbol}</td>
                  <td className="whitespace-nowrap text-center">{acc.Highest_Position_Lot_Size}</td>
                  <td className="whitespace-nowrap text-center">{acc.Highest_Position_Signal}</td>
                  <td className="whitespace-nowrap text-center">{acc.Pending_Orders}</td>
                  <td className="whitespace-nowrap text-center">
                    <button onClick={() => handleDelete(acc.Account_Number)} className="bg-red-600 hover:bg-red-700 text-white rounded px-2 py-1 flex items-center justify-center mx-auto">
                      <FiTrash2 />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// Standard KPI card
const KPI = ({ icon, label, value, color, darkMode, subValue, subValueColor = "text-yellow-400", valueColor = "text-[#1FB0FF]", subtitle }) => (
  <div className={`${darkMode ? "bg-[#13162C]" : "bg-gray-100"} w-full min-w-[200px] h-[100px] rounded-xl px-4 py-4 shadow relative overflow-hidden flex flex-col justify-between`}>
    <div className="text-xs font-semibold uppercase tracking-wider pe-14">{label}</div>
    <div className="pe-14">
      <div className="flex items-baseline gap-3">
        <div className={`text-xl font-bold ${valueColor}`}>{value}</div>
        {subValue && <div className={`text-lg font-bold ${subValueColor}`}>{subValue}</div>}
      </div>
      {subtitle && <div className="text-[10px] mt-1 opacity-70 leading-tight">{subtitle}</div>}
    </div>
    <div className={`absolute bottom-3 end-3 p-2 rounded-lg text-white text-2xl ${color} rotate-[30deg]`}>
      {icon}
    </div>
  </div>
);

// Equity has a dedicated layout so the net-profit rate never overlaps the
// equity amount or icon. On mobile the rate is placed below the amount.
const EquityKPI = ({ icon, label, value, netLabel, netValue, netValueColor, color, darkMode, mobile = false }) => (
  <div className={`${darkMode ? "bg-[#13162C]" : "bg-gray-100"} w-full ${mobile ? "h-[104px]" : "min-w-[200px] h-[100px]"} rounded-xl px-4 py-3 shadow relative overflow-hidden`}>
    <div className="text-xs font-semibold uppercase tracking-wider pe-14">{label}</div>
    {mobile ? (
      <div className="mt-2 pe-10">
        <div className="text-base font-bold text-[#1FB0FF]" dir="ltr">{value}</div>
        <div className="mt-1 flex items-baseline gap-2 flex-wrap">
          <span className="text-[10px] font-semibold opacity-80">{netLabel}</span>
          <span className={`text-xs font-bold ${netValueColor}`} dir="ltr">{netValue}</span>
        </div>
      </div>
    ) : (
      <div className="absolute inset-x-4 bottom-3 pe-14 flex items-end justify-between gap-4" dir="ltr">
        <div className="text-xl font-bold text-[#1FB0FF] whitespace-nowrap">{value}</div>
        <div className="text-end min-w-[86px]">
          <div className="text-[10px] font-semibold opacity-80 whitespace-nowrap">{netLabel}</div>
          <div className={`text-base font-bold ${netValueColor} whitespace-nowrap`}>{netValue}</div>
        </div>
      </div>
    )}
    <div className={`absolute bottom-3 end-3 p-2 rounded-lg text-white ${mobile ? "text-xl" : "text-2xl"} ${color} rotate-[30deg]`}>
      {icon}
    </div>
  </div>
);

const MobileKPI = ({ icon, label, value, color, darkMode, subValue, subValueColor = "text-yellow-400", valueColor = "text-[#1FB0FF]", subtitle }) => (
  <div className={`${darkMode ? "bg-[#13162C]" : "bg-gray-100"} w-full ${subtitle ? "h-[102px]" : "h-[90px]"} rounded-lg px-3 py-3 shadow relative overflow-hidden flex flex-col justify-between`}>
    <div className="text-[10px] font-semibold uppercase tracking-wider pe-9">{label}</div>
    <div className="pe-9">
      <div className="flex items-baseline gap-2">
        <div className={`text-base font-bold ${valueColor}`}>{value}</div>
        {subValue && <div className={`text-xs font-bold ${subValueColor}`}>{subValue}</div>}
      </div>
      {subtitle && <div className="text-[9px] mt-1 opacity-70 leading-tight">{subtitle}</div>}
    </div>
    <div className={`absolute bottom-2 end-2 p-1 rounded-lg text-white text-xl ${color} rotate-[30deg]`}>
      {icon}
    </div>
  </div>
);
